/* tslint:disable */
/* eslint-disable */
/**
 * Tumelo API
 * This is Tumelo\'s API. It drives increased shareholder engagement by providing transparency of the organizations owned by investors and giving them a voice by allowing them to vote on important issues at these organizations.  The main uses of this API are:  * Transparency - To provide a breakdown to an investor of the organizations in which they are invested. * Voting - To provide the ability for an investor to vote on a poll concerning organizations in which they are invested.  ## Status  This API is currently available as a closed **BETA**. We invite interested parties to [give us feedback](mailto:support@tumelo.com) on this API, its documentation, or anything else about Tumelo\'s transparency service prior to the API becoming generally available.  ## Changelog  A changelog for the api can be found [here](CHANGELOG.md).  ## Access The API is available at the following URL: ``` https://api.prod.tumelo.com/v1 ```  For information on how to obtain access to the API, please [contact us](mailto:support@tumelo.com).  ## Development vs Production Habitats Development and Production environments are separated into their own habitats. Please [contact us](mailto:support@tumelo.com) when you\'re ready to go into production and require access to your company\'s live habitat.  # Using the API  ## Case Sensitivity URLs, headers, path parameters, query parameter names, and query parameter values are all case sensitive. Be careful to use the correct case when constructing requests.  ## Error Handling Requests may return an error indicating that there was a problem responding. The response will contain an HTTP status code as well as a JSON object in the following format which describes the error in more detail: ```json {   \"message\": \"Resource not found\" } ```  ## Pagination Requests that return lists and describe pagination parameters support paginated results. Results are separated into multiple pages, where the size of each page is determined by the `pageSize` query parameter. If omitted, `pageSize` defaults to 50 records. When a response includes a `nextPageToken` in the response body, this token value should be passed as a query parameter `nextPageToken` to the same endpoint in order to retrieve the next page of results. This process should be repeated until the response doesn’t include a `nextPageToken`, indicating that the end of the results has been reached.  When passing the `nextPageToken` parameter, all other filter and query parameters present in the previous request, **must** be filled. Filter parameters *must not* be changed while paginating since this will result in an error or an incorrect overall list. The `nextPageToken` will not be present in the response body if the end of the list has been reached and no further results are available.  ## String Formats The following string formats are used throughout this API.  ### date-time The valid format is date-time notation as defined by [RFC 3339, section 5.6](https://tools.ietf.org/html/rfc3339#section-5.6).  For example: `2020-11-30T10:45:28Z`  # Support If you have any technical questions relating to the Tumelo API, please [contact us](mailto:support@tumelo.com), explaining your question or issue in as much detail as possible, including the operation you were performing and the ISIN or Organization ID you were querying, as well as the results you expected and the actual results or error message you observed. You can expect a response within one business day.  ## Data Issues During development and testing in your development habitat we make available a test data set that includes some sample data constructed to illustrate functionality. It is not intended to be used for any purpose other than testing and/or demonstrating functionality, and should not be relied upon to be an accurate reflection of the underlying holdings of any real fund.  If you have any questions or concerns about the data accuracy or completeness of the data in the production environment, please [report the matter](mailto:support@tumelo.com) to us, giving as much information as possible about the issue.  # Compositions and Breakdowns  An instrument may have a composition, this means it is a fund invested in other instruments.  A breakdown is the bottom level components of a composite instrument or account. By this, we mean organizations and cash that a particular composite instrument or account is invested into either directly or through funds.  Breakdowns also have an `other` listing, this is for funds that only have partial information available, or where an instrument is not mapped to an organization. 
 *
 * The version of the OpenAPI document: 0.145.1
 * Contact: support@tumelo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompositeInstrumentBreakdown,
  ComputeCompositeInstrumentBreakdownGraphRequest,
  GetHabitatStatisticsResponse,
  InstrumentBreakdown,
  ListHabitatInstrumentsRequest,
  ListHabitatInstrumentsResponse,
  ListHabitatInstrumentsResponse2,
  OrganizationBreakdown,
} from '../models';
import {
    CompositeInstrumentBreakdownFromJSON,
    CompositeInstrumentBreakdownToJSON,
    ComputeCompositeInstrumentBreakdownGraphRequestFromJSON,
    ComputeCompositeInstrumentBreakdownGraphRequestToJSON,
    GetHabitatStatisticsResponseFromJSON,
    GetHabitatStatisticsResponseToJSON,
    InstrumentBreakdownFromJSON,
    InstrumentBreakdownToJSON,
    ListHabitatInstrumentsRequestFromJSON,
    ListHabitatInstrumentsRequestToJSON,
    ListHabitatInstrumentsResponseFromJSON,
    ListHabitatInstrumentsResponseToJSON,
    ListHabitatInstrumentsResponse2FromJSON,
    ListHabitatInstrumentsResponse2ToJSON,
    OrganizationBreakdownFromJSON,
    OrganizationBreakdownToJSON,
} from '../models';

export interface ComputeCompositeInstrumentBreakdownGraphOperationRequest {
    habitatId: string;
    computeCompositeInstrumentBreakdownGraphRequest?: ComputeCompositeInstrumentBreakdownGraphRequest;
}

export interface GetFilteredSubscribedInstrumentsRequest {
    habitatId: string;
    listHabitatInstrumentsRequest?: ListHabitatInstrumentsRequest;
}

export interface GetHabitatStatisticsRequest {
    habitatId: string;
}

export interface GetInstrumentBreakdownByIsinInHabitatRequest {
    habitatId: string;
    isin: string;
    newBreakdown?: boolean;
}

export interface GetOrganizationBreakdownByIsinInHabitatRequest {
    habitatId: string;
    isin: string;
    newBreakdown?: boolean;
}

export interface GetSubscribedInstrumentsRequest {
    habitatId: string;
}

/**
 * HabitatsApi - interface
 * 
 * @export
 * @interface HabitatsApiInterface
 */
export interface HabitatsApiInterface {
    /**
     * Returns the breakdown of the composite instrument in terms of the organizations,  non-composite instruments and composite instruments that make up the latest composition.  The endpoint will return a `400 Bad Request` error when the security identifier is  malformed or not supplied.  The endpoint will return a `404 Not Found` error when the breakdown cannot be computed  due to either the requested fund not belonging to the supplied habitat, the fund containing  no composition or the latest composition being empty. 
     * @summary Compute breakdown for a CompositeInstrument
     * @param {string} habitatId The habitat identifier.
     * @param {ComputeCompositeInstrumentBreakdownGraphRequest} [computeCompositeInstrumentBreakdownGraphRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitatsApiInterface
     */
    computeCompositeInstrumentBreakdownGraphRaw(requestParameters: ComputeCompositeInstrumentBreakdownGraphOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompositeInstrumentBreakdown>>;

    /**
     * Returns the breakdown of the composite instrument in terms of the organizations,  non-composite instruments and composite instruments that make up the latest composition.  The endpoint will return a `400 Bad Request` error when the security identifier is  malformed or not supplied.  The endpoint will return a `404 Not Found` error when the breakdown cannot be computed  due to either the requested fund not belonging to the supplied habitat, the fund containing  no composition or the latest composition being empty. 
     * Compute breakdown for a CompositeInstrument
     */
    computeCompositeInstrumentBreakdownGraph(requestParameters: ComputeCompositeInstrumentBreakdownGraphOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompositeInstrumentBreakdown>;

    /**
     * Returns details of subscribed instruments in a habitat, for the given instrument references.  The request body must contain instrument references (up to a max of 100 instrument references) of the desired instrument resources. 
     * @summary Get subscribed instruments with the given instrument references.
     * @param {string} habitatId The habitat identifier.
     * @param {ListHabitatInstrumentsRequest} [listHabitatInstrumentsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitatsApiInterface
     */
    getFilteredSubscribedInstrumentsRaw(requestParameters: GetFilteredSubscribedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListHabitatInstrumentsResponse2>>;

    /**
     * Returns details of subscribed instruments in a habitat, for the given instrument references.  The request body must contain instrument references (up to a max of 100 instrument references) of the desired instrument resources. 
     * Get subscribed instruments with the given instrument references.
     */
    getFilteredSubscribedInstruments(requestParameters: GetFilteredSubscribedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListHabitatInstrumentsResponse2>;

    /**
     * Returns statistics for a habitat 
     * @summary Get habitat statistics
     * @param {string} habitatId The habitat identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitatsApiInterface
     */
    getHabitatStatisticsRaw(requestParameters: GetHabitatStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHabitatStatisticsResponse>>;

    /**
     * Returns statistics for a habitat 
     * Get habitat statistics
     */
    getHabitatStatistics(requestParameters: GetHabitatStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHabitatStatisticsResponse>;

    /**
     * Returns the breakdown of the instrument in terms of the instruments that are the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. 
     * @summary Get instrument breakdown
     * @param {string} habitatId The habitat identifier.
     * @param {string} isin The ISIN of the fund or composite instrument for which information is required.
     * @param {boolean} [newBreakdown] Passing a newBreakdown parameter with value &#x60;true&#x60; will compute the breakdown using the fund model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitatsApiInterface
     */
    getInstrumentBreakdownByIsinInHabitatRaw(requestParameters: GetInstrumentBreakdownByIsinInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstrumentBreakdown>>;

    /**
     * Returns the breakdown of the instrument in terms of the instruments that are the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. 
     * Get instrument breakdown
     */
    getInstrumentBreakdownByIsinInHabitat(requestParameters: GetInstrumentBreakdownByIsinInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstrumentBreakdown>;

    /**
     * Returns the breakdown of the instrument in terms of the organizations that issued the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. 
     * @summary Get organization breakdown
     * @param {string} habitatId The habitat identifier.
     * @param {string} isin The ISIN of the fund or composite instrument for which information is required.
     * @param {boolean} [newBreakdown] Passing a newBreakdown parameter with value &#x60;true&#x60; will compute the breakdown using the fund model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitatsApiInterface
     */
    getOrganizationBreakdownByIsinInHabitatRaw(requestParameters: GetOrganizationBreakdownByIsinInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationBreakdown>>;

    /**
     * Returns the breakdown of the instrument in terms of the organizations that issued the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. 
     * Get organization breakdown
     */
    getOrganizationBreakdownByIsinInHabitat(requestParameters: GetOrganizationBreakdownByIsinInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationBreakdown>;

    /**
     * Returns a habitat\'s list of subscribed instruments. 
     * @summary Get Subscribed Instruments
     * @param {string} habitatId The habitat identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitatsApiInterface
     */
    getSubscribedInstrumentsRaw(requestParameters: GetSubscribedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListHabitatInstrumentsResponse>>;

    /**
     * Returns a habitat\'s list of subscribed instruments. 
     * Get Subscribed Instruments
     */
    getSubscribedInstruments(requestParameters: GetSubscribedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListHabitatInstrumentsResponse>;

}

/**
 * 
 */
export class HabitatsApi extends runtime.BaseAPI implements HabitatsApiInterface {

    /**
     * Returns the breakdown of the composite instrument in terms of the organizations,  non-composite instruments and composite instruments that make up the latest composition.  The endpoint will return a `400 Bad Request` error when the security identifier is  malformed or not supplied.  The endpoint will return a `404 Not Found` error when the breakdown cannot be computed  due to either the requested fund not belonging to the supplied habitat, the fund containing  no composition or the latest composition being empty. 
     * Compute breakdown for a CompositeInstrument
     */
    async computeCompositeInstrumentBreakdownGraphRaw(requestParameters: ComputeCompositeInstrumentBreakdownGraphOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompositeInstrumentBreakdown>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling computeCompositeInstrumentBreakdownGraph.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/instruments/breakdownGraph`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ComputeCompositeInstrumentBreakdownGraphRequestToJSON(requestParameters.computeCompositeInstrumentBreakdownGraphRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompositeInstrumentBreakdownFromJSON(jsonValue));
    }

    /**
     * Returns the breakdown of the composite instrument in terms of the organizations,  non-composite instruments and composite instruments that make up the latest composition.  The endpoint will return a `400 Bad Request` error when the security identifier is  malformed or not supplied.  The endpoint will return a `404 Not Found` error when the breakdown cannot be computed  due to either the requested fund not belonging to the supplied habitat, the fund containing  no composition or the latest composition being empty. 
     * Compute breakdown for a CompositeInstrument
     */
    async computeCompositeInstrumentBreakdownGraph(requestParameters: ComputeCompositeInstrumentBreakdownGraphOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompositeInstrumentBreakdown> {
        const response = await this.computeCompositeInstrumentBreakdownGraphRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns details of subscribed instruments in a habitat, for the given instrument references.  The request body must contain instrument references (up to a max of 100 instrument references) of the desired instrument resources. 
     * Get subscribed instruments with the given instrument references.
     */
    async getFilteredSubscribedInstrumentsRaw(requestParameters: GetFilteredSubscribedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListHabitatInstrumentsResponse2>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getFilteredSubscribedInstruments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/instruments:getFilteredSubscribedInstruments`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListHabitatInstrumentsRequestToJSON(requestParameters.listHabitatInstrumentsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListHabitatInstrumentsResponse2FromJSON(jsonValue));
    }

    /**
     * Returns details of subscribed instruments in a habitat, for the given instrument references.  The request body must contain instrument references (up to a max of 100 instrument references) of the desired instrument resources. 
     * Get subscribed instruments with the given instrument references.
     */
    async getFilteredSubscribedInstruments(requestParameters: GetFilteredSubscribedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListHabitatInstrumentsResponse2> {
        const response = await this.getFilteredSubscribedInstrumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns statistics for a habitat 
     * Get habitat statistics
     */
    async getHabitatStatisticsRaw(requestParameters: GetHabitatStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHabitatStatisticsResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getHabitatStatistics.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/statistics`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHabitatStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Returns statistics for a habitat 
     * Get habitat statistics
     */
    async getHabitatStatistics(requestParameters: GetHabitatStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHabitatStatisticsResponse> {
        const response = await this.getHabitatStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the breakdown of the instrument in terms of the instruments that are the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. 
     * Get instrument breakdown
     */
    async getInstrumentBreakdownByIsinInHabitatRaw(requestParameters: GetInstrumentBreakdownByIsinInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstrumentBreakdown>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getInstrumentBreakdownByIsinInHabitat.');
        }

        if (requestParameters.isin === null || requestParameters.isin === undefined) {
            throw new runtime.RequiredError('isin','Required parameter requestParameters.isin was null or undefined when calling getInstrumentBreakdownByIsinInHabitat.');
        }

        const queryParameters: any = {};

        if (requestParameters.newBreakdown !== undefined) {
            queryParameters['newBreakdown'] = requestParameters.newBreakdown;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/instruments/{isin}/instrumentBreakdown`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"isin"}}`, encodeURIComponent(String(requestParameters.isin))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstrumentBreakdownFromJSON(jsonValue));
    }

    /**
     * Returns the breakdown of the instrument in terms of the instruments that are the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. 
     * Get instrument breakdown
     */
    async getInstrumentBreakdownByIsinInHabitat(requestParameters: GetInstrumentBreakdownByIsinInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstrumentBreakdown> {
        const response = await this.getInstrumentBreakdownByIsinInHabitatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the breakdown of the instrument in terms of the organizations that issued the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. 
     * Get organization breakdown
     */
    async getOrganizationBreakdownByIsinInHabitatRaw(requestParameters: GetOrganizationBreakdownByIsinInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationBreakdown>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getOrganizationBreakdownByIsinInHabitat.');
        }

        if (requestParameters.isin === null || requestParameters.isin === undefined) {
            throw new runtime.RequiredError('isin','Required parameter requestParameters.isin was null or undefined when calling getOrganizationBreakdownByIsinInHabitat.');
        }

        const queryParameters: any = {};

        if (requestParameters.newBreakdown !== undefined) {
            queryParameters['newBreakdown'] = requestParameters.newBreakdown;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/instruments/{isin}/organizationBreakdown`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"isin"}}`, encodeURIComponent(String(requestParameters.isin))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationBreakdownFromJSON(jsonValue));
    }

    /**
     * Returns the breakdown of the instrument in terms of the organizations that issued the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. 
     * Get organization breakdown
     */
    async getOrganizationBreakdownByIsinInHabitat(requestParameters: GetOrganizationBreakdownByIsinInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationBreakdown> {
        const response = await this.getOrganizationBreakdownByIsinInHabitatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a habitat\'s list of subscribed instruments. 
     * Get Subscribed Instruments
     */
    async getSubscribedInstrumentsRaw(requestParameters: GetSubscribedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListHabitatInstrumentsResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getSubscribedInstruments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/instruments`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListHabitatInstrumentsResponseFromJSON(jsonValue));
    }

    /**
     * Returns a habitat\'s list of subscribed instruments. 
     * Get Subscribed Instruments
     */
    async getSubscribedInstruments(requestParameters: GetSubscribedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListHabitatInstrumentsResponse> {
        const response = await this.getSubscribedInstrumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
